<!--商品详情-->
<template>
  <div class="box">
    <div class="goods-box" v-if="loading">
      <div class="goods-banner-fill">
        <van-swipe
          indicator-color="#FD2840"
          :duration="duration"
          @change="onSwipeChange"
          :loop="loop"
          ref="swipe"
        >
          <van-swipe-item v-if="detail.videos_url" @click="toGoodsVideo">
            <img :src="detail.videos_url" alt v-lazy="detail.videos_url" />
            <img
              src="../../../assets/images/icon-video-play.png"
              class="video-img"
              alt
            />
          </van-swipe-item>
          <van-swipe-item v-for="item in detail.pics_url" :key="item.id">
            <img :src="item" alt />
          </van-swipe-item>
          <van-swipe-item v-if="picCount > 0">
            <div class="swipe-text">继续滑动查看图文详情</div>
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="goods-detail">
        <div class="goods-pri">
          <div class="goods-price-top">
            <div class="goods-price">
              <div class="goods-price1">¥</div>
              <div class="goods-price2">{{ detail.price_range_1 }}</div>
              <div class="goods-price1" v-if="detail.price_range_2">
                .{{ detail.price_range_2 }}
              </div>
            </div>
            <div
              class="scroll-goods-item0-seller-price"
              style="margin-left: 5px"
              v-if="detail.max_seller_reward > 0"
            >
              <div class="fan">赚</div>
              <div class="seller-price">¥{{ detail.max_seller_reward }}</div>
            </div>
          </div>
          <div class="row-left">
            已售 {{ detail.sold_count + detail.sold_show_count }}
          </div>

          <!-- <div class="goods-price-thr gray-light">
            ¥{{detail.orig_price|price}}
          </div>-->
        </div>

        <div class="goods-name show-two-row">{{ detail.title }}</div>
        <div class="goods-label">
          <div>·正品保证</div>
          <div>·极速发货</div>
          <div>·超值底价</div>
          <div>·售后无忧</div>
        </div>

        <div style="padding: 0px 15px" v-if="detail.credit_limit > 0">
          <div class="clear to-buy-vip-box">
            <div class="buy-vip-msg-box hide-txt">
              <div class="buy-vip-msg hide-txt">
                使用积分立减{{ detail.credit_limit }}元
              </div>
            </div>
            <div
              class="to-buy-vip"
              v-rblink="{ name: 'cmsDetail', query: { type: 'help', id: 5 } }"
            >
              获取积分
              <span class="arrow-by-border"></span>
            </div>
          </div>
        </div>

        <!--        <van-cell title="库存余额" :value="'仅剩'+detail.stock+'件'"></van-cell>-->

        <div class="share-box share-right">
          <div
            class="share-right-text"
            v-if="detail.max_seller_reward > 0"
            @click="getShare"
          >
            分享好友可赚
            <div>￥{{ detail.max_seller_reward }}</div>
          </div>
          <div class="share-right-texts" v-else @click="getShare">
            分享给好友
          </div>
        </div>

        <div class="row-tips" v-if="detail.discount_tags.length > 0">
          <GoodsDetailTips :discount="detail.discount_tags"></GoodsDetailTips>
        </div>
      </div>

      <div class="row-list app-border-top">
        <div
          :key="index"
          class="app-border-bottom flex-between row-one"
          v-for="(item, index) in detail.extra_data"
        >
          <span>{{ item.name }}</span>
          <span>{{ item.value }}</span>
        </div>
      </div>
      <!--      <div class="app-border-top">-->
      <!--        <van-cell title="商品评价" is-link @click="toGoodsComment"/>-->
      <!--      </div>-->

      <div class="detail-content" v-show="detail.music.length > 0">
        <div></div>
        <span>试听音乐</span>
        <div></div>
      </div>
      <div class="music-list">
        <van-steps
          direction="vertical"
          :active="mp3Active"
          active-icon="checked"
          inactive-icon="circle"
        >
          <van-step v-for="(item, i) in detail.music" :key="i">
            <p class="course-title" @click="onPlayItems(i)">{{ item.name }}</p>
            <p class="course-info" @click="onPlayItems(i)">点击播放</p>
          </van-step>
        </van-steps>
      </div>

      <div class="detail-content" id="detail">
        <div></div>
        <span>商品详情</span>
        <div></div>
      </div>
      <div class="detail-img" v-html="detail.content"></div>

      <div class="detail-title" v-show="loveGoods.length > 0">
        <div></div>
        <span>猜你喜欢</span>
        <div></div>
      </div>

      <div style="background: #efefef; overflow: hidden">
        <div class="love_goods">
          <div
            class="love_goods_items"
            v-for="(item, i) in loveGoods"
            :key="i"
            @click="getLoveGoods(item.id)"
          >
            <img :src="item.pic_url" alt />
            <div class="love_goods_title">{{ item.title }}</div>
            <div style="display: flex; align-items: center">
              <div class="goods-price" style="margin-left: 5px">
                <div class="goods-price1">¥</div>
                <div class="goods-price2">{{ item.price_range_1 }}</div>
                <div class="goods-price1" v-if="item.price_range_2">
                  .{{ item.price_range_2 }}
                </div>
              </div>
              <div class="goods-price-thr gray-light" style="margin-left: 5px">
                ¥{{ item.orig_price | price }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <CopyRight></CopyRight> -->
    <!-- <van-goods-action class="goods-footer">
      <van-goods-action-icon class="footer-kf" @click="goHome" icon="home-o">
        <p>首页</p>
      </van-goods-action-icon>
      <van-goods-action-icon class="footer-kf" icon="chat-o" @click="onChat">
        <p>客服</p>
      </van-goods-action-icon>
      <van-goods-action-icon class="footer-kf" :info="cart_count" @click="goCart" v-if="cart_count> 0"
                             icon="cart-o">
        <p>购物车</p>
      </van-goods-action-icon>
      <van-goods-action-icon class="footer-kf" @click="goCart" v-else icon="cart-o">
        <p>购物车</p>
      </van-goods-action-icon>

      <van-goods-action-button text="加入购物车" type="warning" @click="showSkuPicker = true"/>
      <van-goods-action-button primary text="立即购买" type="danger" @click="showSkuPicker = true"/>
    </van-goods-action>-->
    <div style="height: 60px; width: 100%"></div>
    <div class="goods-footer">
      <div class="flex-between" style="height: 60px; padding: 0 15px">
        <div class="goods-action-left">
          <div class="action-left-icon-box" @click="goHome">
            <img
              class="icon-goods-detail"
              mode="widthFix"
              src="https://static.dierqudao.com/images/vfd/icon-detail-hone.png"
            />
            首页
          </div>
          <div class="action-left-icon-box" @click="onChat">
            <img
              class="icon-goods-detail"
              mode="widthFix"
              src="https://static.dierqudao.com/images/vfd/icon-detail-kefu.png"
            />客服
          </div>
          <div class="action-left-icon-box" @click="goCart">
            <img
              class="icon-goods-detail"
              mode="widthFix"
              src="https://static.dierqudao.com/images/vfd/icon-detail-cart.png"
            />购物车
            <div class="action-cart-count" v-if="cart_count > 0">
              {{ cart_count }}
            </div>
          </div>
        </div>
        <div class="buys-box">
          <div class="goods-add-cart" @click="showSkuPicker = true">
            加入购物车
          </div>
          <div class="goods-buy" @click="showSkuPicker = true">立刻购买</div>
        </div>
      </div>
    </div>
    <div class="shareShow" v-if="showWxShare" @click="onShareCancel">
      <div>
        <h2>点击分享给好友</h2>
      </div>
    </div>

    <!-- 基础用法 -->
    <div class="sku-container">
      <van-sku
        v-model="showSkuPicker"
        :sku="skuData.sku"
        :goods="skuData.goods"
        :goods-id="skuData.goods_id"
        :quota="skuData.quota"
        :quota-used="skuData.quotaUsed"
        :properties="skuData.properties"
        :custom-stepper-config="customStepperConfig"
        :hide-stock="skuData.hide_stock"
        :close-on-click-overlay="closeOnClickOverlay"
        :message-config="messageConfig"
        @buy-clicked="onBuyClicked"
        @add-cart="onAddCartClicked"
      />
    </div>
    <LoginDialog
      :show="loginShow"
      @loginSuccess="loginSuccess"
      @loginCancel="loginCancel"
    />
    <ShareDialog
      :show="shareShow"
      :reward="detail.max_seller_reward"
      :goods_id="detail.id"
      :share="share"
      @shareCancel="shareCancel"
    />
    <ActivityDialog :row="detail.activity"></ActivityDialog>
    <BookDialog
      :show="bookDialogShow"
      :wxNote="chat.note"
      :wxCode="chat.wxcode"
      :wxPic="chat.pic_url"
      :phone="chat.phone"
      @onBookCancle="onBookCancle"
    ></BookDialog>

    <van-popup
      v-model="showMusic"
      closeable
      position="bottom"
      :style="{ height: '30%' }"
    >
      <div style="text-align: center">
        <audio
          autoplay
          style="margin: 10px auto"
          v-if="playMusicUrl && showMusic"
          :src="playMusicUrl"
          controls="controls"
        ></audio>
        <div style="margin: 20px 0 0 0">{{ playMusicName }}</div>
      </div>
    </van-popup>
  </div>
</template>
<style scoped>
/* vip卡 开卡 */
.to-buy-vip-box {
  font-size: 12px;
  line-height: 16px;
  color: #222;
  position: relative;
}

.music-list {
  padding: 10px;
}

.course-info {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 0.85);
}
.course-title {
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  line-height: 20px;
}
.to-buy-vip {
  padding: 10px 22px 9px 12px;
  background-color: #ede9e0;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
}

.is-vip {
  padding-right: 12px;
}

.to-buy-vip .arrow-by-border {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%) rotateZ(45deg);
  width: 6px;
  height: 6px;
}

.buy-vip-msg-box {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 58px 9px 12px;
  text-align: left;
  background-color: #f7f5f0;
  position: relative;
}

.icon-vip {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 13px;
  height: 13px;
}

.icon-vip span {
  display: inline-block;
  vertical-align: middle;
  height: 13px;
  line-height: 13px;
  padding: 0 6px;
  font-size: 9px;
  background-color: #51443d;
  color: #ffffff;
}

.buy-vip-msg {
  font-size: 12px;
  padding: 0 30px 0 18px;
}
.swipe-text {
  width: 14px;
  line-height: 18px;
  padding-top: 0.5rem;
  font-size: 14px;
  margin: 0 10px 0;
}

.detail-content {
  height: 59px;
  font-size: 16px;
  font-weight: 800;
  color: rgba(51, 51, 51, 1);
  line-height: 59px;
  padding: 0 10px;
}

.action-cart-count {
  position: absolute;
  top: -5px;
  right: -2px;
  width: 15px;
  height: 15px;
  background: rgba(250, 74, 85, 1);
  border-radius: 15px;
  text-align: center;
  line-height: 15px;
  color: #fff;
}

.goods-add-cart {
  width: 2rem;
  height: 0.75rem;
  background: rgba(51, 51, 51, 1);
  border-radius: 5px;
  font-size: 12px;
  font-weight: 800;
  color: rgba(255, 255, 255, 1);
  line-height: 0.75rem;
  text-align: center;
}

.goods-buy {
  width: 2rem;
  height: 0.75rem;
  background: rgba(250, 74, 85, 1);
  border-radius: 5px;
  font-size: 12px;
  font-weight: 800;
  color: rgba(255, 255, 255, 1);
  line-height: 0.75rem;
  margin-left: 4px;
  text-align: center;
}

.icon-goods-detail {
  width: 14px;
  margin-bottom: 4px;
}

.action-left-icon-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  font-size: 10px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(55, 55, 55, 1);
  position: relative;
}

.goods-action-left {
  flex: 1;
  display: flex;
  justify-content: space-around;
}

.buys-box {
  display: flex;
  margin-left: 7.5px;
}

.goods-footer {
  position: fixed;
  bottom: 0;
  height: 60px;
  width: 100%;
  background: #fff;
}

.goods-label {
  border-top: 1px solid #cccccc;
  width: 100%;
  height: 40px;
  margin: 0 auto;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(153, 153, 153, 1);
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  padding-right: 10px;
  line-height: 40px;
}

.row-left {
  font-size: 26 rpx;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(153, 153, 153, 1);
}

.goods-pri {
  display: flex;
  justify-content: space-between;
}

.show-two-row {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.goods-price-top {
  display: flex;
}

.scroll-goods-item0-seller-price {
  display: flex;
  justify-content: space-between;
  border: 1px solid #fd2840;
  border-radius: 4px;
  height: 15px;
  line-height: 15px;
  overflow: hidden;
}

.scroll-goods-item0-seller-price .fan {
  background: #fd2840;
  color: #fff;
  font-size: 12px;
  padding: 0 2px;
  line-height: 15px;
}

.scroll-goods-item0-seller-price .seller-price {
  color: #fd2840;
  font-size: 12px;
  padding: 0 2px;
  line-height: 15px;
}

.goods-price1 {
  font-size: 12px;
  display: flex;
  align-items: flex-end;
}

.goods-price2 {
  font-size: 16px;
  align-items: flex-end;
}

.love_goods {
  width: 7.1rem;
  background: #efefef;
  margin: 10px auto;

  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.love_goods_items {
  width: 3.45rem;
  padding-bottom: 10px;
  overflow: hidden;
  border-radius: 7px;
  margin-bottom: 10px;
  background: #fff;
}

.love_goods_items img {
  width: 100%;
}

.love_goods_title {
  font-size: 13px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(31, 32, 33, 1);
  line-height: 15px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  padding: 0 5px;
  margin-bottom: 5px;
}

.box {
  margin-bottom: 50px;
}

.van-swipe .video-img {
  position: absolute;
  left: 3.25rem;
  top: 2.1rem;
  z-index: 20px;
  width: 50px;
  height: 50px;
}

.copybox {
  padding: 0.2rem 0 0.6rem;
}

.share {
  /*border-bottom: 1px solid #EFEFEF;*/
  padding-bottom: 0.1rem;
}

.shareShow {
  position: fixed;
  text-align: center;
  width: 100%;
  height: 100%;
  z-index: 10000;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.68);
  color: rgb(255, 255, 255);
}

.shareShow div {
  background: url(https://static.dierqudao.com/images/cheesemanv2.0/icon_share_arrow.png)
    no-repeat right top;
  height: 100%;
  background-size: 100px;
  padding: 180px 0 0 0;
  margin: 10px;
  line-height: 40px;
}

.shareShow h2 {
  /*font-size: 1.8rem*/
  font-size: 0.8rem;
}

.share-box {
  position: fixed;
  right: 20px;
  /*top: 60%;*/
  top: 53%;
  z-index: 8;
}

.share-right {
  margin-right: -50px;
  width: 153px;
  height: 49px;
  line-height: 49px;
  background: linear-gradient(
    180deg,
    rgba(255, 101, 131, 1) 0%,
    rgba(253, 53, 76, 1) 100%
  );
  box-shadow: 0px 2px 6px 0px rgba(255, 66, 90, 1);
  border-radius: 46px;
  text-align: center;
}

.share-right-text {
  width: 124px;
  height: 44px;
  font-size: 14px;
  padding-top: 4px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
}

.share-right-texts {
  width: 124px;
  height: 44px;
  font-size: 14px;
  padding-top: 4px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 40px;
}

.van-goods-action-icon__icon {
  color: #7d7e80;
  font-size: 20px;
}

.sku-container >>> .van-button--warning {
  color: #fff;
  background-color: #f44;
}

.sku-container >>> .van-button--danger {
  color: #fff;
  background-color: #ff976a;
  border: 1px solid #ff976a;
}

.row-list {
  color: #181818;
  font-size: 12px;
  padding: 0 15.5px;
}

.row-one {
  padding: 15.5px 0;
}

.app-border-top {
  border-top: 0.1rem solid #efefef;
}

.app-border-bottom {
  border-bottom: 1px solid #efefef;
}

.flex-end {
  justify-content: flex-end;
}

.header-user-text {
  width: 80px;
  text-align: center;
}

.goods-header {
  height: 45px;
  /*line-height: 45px;*/
  background: #e43131;
  color: #fff;
  padding-right: 0.2rem;

  display: flex;
  justify-content: space-between;
}

.header-left {
  width: 2.5rem;
  background: #ae1f1f;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  font-size: 12px;
  padding-left: 0.2rem;

  float: left;
}

.header-left img {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  margin-right: 0.1rem;
}

.header-right {
  width: 250px;
  height: 45px;
  color: #fff;
}

.goods-banner-fill img {
  width: 100%;
  height: 100%;
}

.goods-name {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 800;
  color: rgba(51, 51, 51, 1);
  margin: 10px 0;
}

.goods-detail {
  padding: 0 0.3rem;
}

.good-pri-earn {
  width: auto;
  padding: 2px 2px;
  background: rgba(253, 232, 234, 1);
  border-radius: 2px;
  /* border:2rpx solid rgba(253,40,64,1); */
  font-size: 12px;
  color: #fd2840;
  text-align: center;
  margin-left: 7.5px;
  display: flex;
}

.good-pri-earn img {
  width: 12px;
  height: 12px;
  padding: 2px 4px;
}

.goods-price {
  font-size: 12px;
  color: #fd2840;
  display: flex;
}

.goods-price span {
  font-size: 16px;
  font-weight: 500;
}

.goods-price-thr {
  font-size: 12px;
  text-decoration: line-through;
  margin: 3px 0 0 0.3rem;
}

.row-yf {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  padding: 0.2rem 0;
  border-bottom: 1px solid #efefef;
}

.row-xg {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
  padding: 0.2rem 0;
  /*border-bottom: 1px solid #EFEFEF;*/
}

.row-xg img {
  margin-right: 0.15rem;
}

.row-right {
  width: 16px;
  height: 16px;
  margin-right: 0.1rem;
}

.row-tips {
  padding-bottom: 0.2rem;
  border-bottom: 1px solid #efefef;
}

.shop-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.21rem;
}

.shop-left img {
  width: 0.88rem;
  height: 0.88rem;
  border-radius: 100%;
  margin-right: 0.2rem;
}

.shop-left,
.shop-right {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.shop-right img {
  width: 16px;
  height: 16px;
}

.shop-name {
  font-size: 13px;
}

.shop-right {
  font-size: 12px;
  /*margin-right: 0.2rem;*/
}

.shop-det {
  font-size: 11px;
}

.shop-text {
  height: 100%;
  max-width: 240px;
}

.row-group {
  border-top: 0.1rem solid #efefef;
}

/* .row-group::after{
        border: none;
    } */
.row-group .van-cell {
  width: auto;
  color: #181818;
  font-size: 12px;
  padding: 0.2rem 0;
  margin: 0 0.31rem;
  border-bottom: 1px solid #efefef;
}

.remark-box {
  padding: 0 0.3rem;
}

.remark-header {
  padding: 0.3rem 0;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.remark-good {
  font-size: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.remark-good span {
  color: #fd2840;
  margin-left: 0.1rem;
}

.remark-li img {
  width: 7.09rem;
  height: 3.93rem;
}

.detail-title {
  width: 7.5rem;
  line-height: 0.5rem;
  height: 0.5rem;
  background: rgba(239, 239, 239, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.detail-title div {
  width: 0.62rem;
  height: 1px;
  background: rgba(0, 0, 0, 1);
  opacity: 0.08;
}

.detail-title span {
  margin: 0 0.2rem;
}

.detail-img >>> img {
  width: 100%;
  vertical-align: bottom;
}

.detail-img {
  margin: 0 auto;
  margin-bottom: 50px;
  width: 7.3rem;
}

.detail-img >>> video {
  width: 100%;
}

.like-goods {
  padding: 0 0.23rem;
  background: rgba(239, 239, 239, 1);
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-bottom: 50px;
}

.like-one {
  background: #fff;
  width: 3.45rem;
  margin-bottom: 0.2rem;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.like-one:nth-child(2n) {
  margin-left: 0.13rem;
}

.like-goods-img {
  width: 3.45rem;
  height: 3.45rem;
}

.like-one-name {
  color: #333333;
  height: 0.8rem;
  line-height: 0.4rem;
  font-weight: 500;
  padding: 0 0.2rem;
}

.like-one-pri {
  margin: 0.2rem;
}

.like-one-pri span {
  padding: 2px 3px;
  background: #fd2840;
  font-size: 9px;
  color: #fff;
  border-radius: 2px;
}

.like-one-price {
  padding: 0.2rem;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.like-red-price {
  color: #fd2840;
}

.like-big-pri {
  font-size: 17px;
}

.like-price-thr {
  text-decoration: line-through;
  margin-left: 0.1rem;
}

.footer-kf {
  align-items: center;
}

.footer-kf img {
  width: 20px;
  height: 20px;
  margin: -5px 0 5px 0;
}
</style>

<script>
import Vue from "vue";
import LoginDialog from "@/components/LoginDialog.vue";
import ShareDialog from "@/components/ShareDialog.vue";
import ActivityDialog from "@/components/ActivityDialog.vue";
import BookDialog from "@/components/BookDialog.vue";

import {
  Cell,
  CellGroup,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Sku,
  Toast,
} from "vant";

Vue.use(Cell)
  .use(CellGroup)
  .use(GoodsAction)
  .use(GoodsActionIcon)
  .use(GoodsActionButton)
  .use(Sku)
  .use(Toast);
import GoodsDetailTips from "@/components/GoodsDetailTips.vue";
import CopyRight from "@/components/CopyRight.vue";

export default {
  name: "GoodsDetail",
  components: {
    GoodsDetailTips,
    LoginDialog,
    ShareDialog,
    ActivityDialog,
    BookDialog,
    CopyRight,
  },
  data: function () {
    return {
      bookDialogShow: false,
      mp3Active: 0,
      loginShow: false,
      shareShow: false,
      showMusic: false,
      playMusicUrl: "",
      playMusicName: "",
      loading: false,
      detail: {
        videos_url: "",
        pics_url: [],
        price_range: [],
        express_price: [],
        activity: {},
        discount_tags: [],
      },
      header: {},
      business: {},
      share: {},
      chat: {},

      skuData: {
        sku: {
          none_sku: false, // 是否无规格商品
          hide_stock: false, // 是否隐藏剩余库存
          list: [],
          tree: [],
          messages: [],
        },
        properties: [],
        goods: {},
        goods_id: 0,
        quota: 0,
        quotaUsed: 0,
      },
      showSkuPicker: false,
      closeOnClickOverlay: true,
      showWxShare: false,
      messageConfig: {},
      cart_count: 0,

      duration: 300,
      loop: false,
      customStepperConfig: {
        quotaText: "",
      },
      business_id: 0,
      businessLogo: "",

      loveGoods: [],
      picCount: 0, //图展总数
    };
  },
  filter: {},
  activated() {},
  mounted() {
    document.title = "商品详情";
    let that = this;
    that.getGoodsDetail(this.$route.query.id);

    let href = window.location.href.split("#");
    if (href[1] == "share") {
      that.showWxShare = true;
    }

    window.rbMessage = function (data) {
      if (data == "showGoodsShare") {
        //                    alert('that.fetch()')
        that.getShare();
      }
    };

    that.business_id = localStorage.getItem("_business_id");

    let hash = that.$route.query._seller_id || 0;
    localStorage.setItem("_detail", hash);
  },
  destroyed() {},
  methods: {
    getLoveGoods(id) {
      rbLink({
        name: "GoodsDetail",
        query: { id: id },
      });

      location.reload();
    },
    getProperties(list) {
      let arr = [];
      console.log(list);
      list.map((item, i) => {
        let v_arr = [];
        let v_list = item.value.split("\n");
        console.log(v_list);
        v_list.map((vitem, v) => {
          v_arr.push({
            id: i + v + 2, // 属性值id
            name: vitem.split('=')[0], // 属性值名
            price: parseInt(vitem.split('=')[1])*100, // 属性值加价
          });
        });
        arr.push({
          k_id: i + 1,
          k: item.name,
          is_multiple: false,
          v: v_arr,
        });
      });
      this.skuData.properties = arr;
    },
    getGoodsDetail(id) {
      let that = this;
      let sku = {};
      let total = 0;

      this.$api.get("/api/goods/goodsdetail", { id: id }, (res) => {
        let data = res.data.data;
        that.detail = data;
        that.header = res.data.header;
        that.share = res.data.share;
        that.chat = res.data.chat;
        that.cart_count = res.data.h5_cart_count;

        that.skuData.sku = sku = res.data.sku;
        if (res.data.data.order_data.length > 0) {
          that.getProperties(res.data.data.order_data);
        }

        that.skuData.sku.messages = [];
        that.loveGoods = res.data.love_goods;
        // that.business_id = res.data.data.business_id
        //
        // localStorage.setItem('_business_id', res.data.data.business_id)

        // 计算总图片数量
        let count = 0,
          picCount = data.pics_url.length;
        if (data.videos_url) {
          count++;
        }
        that.picCount = count + picCount;

        that.loading = true;

        that.wxShare(
          res.data.share.title,
          res.data.share.desc,
          res.data.share.url,
          res.data.share.pic_url
        );
        that.skuData.goods = {
          title: that.detail.title,
          picture: that.detail.pic_url,
        };

        // 总数量
        for (let i = 0; i < sku.list.length; i++) {
          total = total + sku.list[i].stock_num;
        }

        that.skuData.sku.stock_num = total;
        that.skuData.sku.price =
          that.detail.price_range[0] + "-" + that.detail.price_range[1];
        that.skuData.goods_id = that.detail.id;
        that.skuData.quota = that.detail.user_buy_limit;
        that.skuData.quotaUsed = that.detail.buy_count;
        if (that.skuData.quota > 0) {
          that.customStepperConfig.quotaText =
            "(每人限购" + that.skuData.quota + "件)";
        }
      });
    },

    // 跳转商品视频
    toGoodsVideo() {
      let id = this.$route.query.id;
      rbLink({
        name: "GoodsVideo",
        query: { id: id },
      });
    },

    // 跳转商品评价
    toGoodsComment() {
      let id = this.$route.query.id;
      rbLink({
        name: "GoodsComment",
        query: { id: id },
      });
    },

    // 轮播图滚动 监听
    onSwipeChange(index) {
      // console.log("onSwipeChange", index)
      let that = this;
      if (index == that.picCount) {
        document.querySelector("#detail").scrollIntoView(true);

        that.$refs.swipe.swipeTo(index - 1, { immediate: true });
      }
    },

    onRule() {
      rbLink({
        name: "ContentDetail",
        query: { id: 8 },
      });
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      let that = this;
      that.loginShow = false;
      // that.showSkuPicker = true
      that.getGoodsDetail();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      this.loginShow = false;
    },

    onChat() {
      if (!this.chat.wxcode) {
        Toast("商户暂未配置");
        return;
      }
      this.bookDialogShow = true;
    },

    onBookCancle() {
      this.bookDialogShow = false;
    },

    shareCancel() {
      console.log("-------取消分享-------");
      this.shareShow = false;
    },
    onShareCancel() {
      this.showWxShare = false;
    },

    getShare() {
      let that = this;
      that.$api.get(
        "/api/cart/detail",
        {},
        (res) => {
          that.shareShow = true;
        },
        (res) => {
          if (res.code == 401 || res.code == 402) {
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },

    goBaseDetail(id) {
      console.log(id);
      rbLink({
        name: "BaseDetail",
        query: { id: id },
      });
    },

    // 立即购买
    onBuyClicked(data) {
      let that = this;
      console.log(data);
      // return ;

      let goods_items = [
        {
          goods_id: data.goodsId,
          sku_id: data.selectedSkuComb.id,
          count: data.selectedNum,
          properties: data.selectedSkuComb.properties,
          property_price: data.selectedSkuComb.property_price,

        },
      ];
      // 存入缓存
      localStorage.setItem(
        "order_check_goods_items",
        JSON.stringify(goods_items)
      );
      rbLink({
        name: "OrderCheck",
        // query: JSON.stringify(goods_items),
      });
    },

    // 加入购物车
    onAddCartClicked(data) {
      let that = this;
      console.log(data)
      let property_name=''
      let property_price=0
      if(data.selectedSkuComb.properties.length){
        data.selectedSkuComb.properties.map((item,i)=>{
          console.log(item.v[0])
          property_price+=item.v[0].price
          property_name=property_name+item.v[0].name+' '
        })
      }
      console.log(property_price)
      console.log(property_name)
      let goods_items = {
        goods_id: data.goodsId,
        sku_id: data.selectedSkuComb.id,
        count: data.selectedNum,
        property_name,
        properties:data.selectedSkuComb.properties,
        property_price
      };
      console.log(goods_items)

      this.$api.post(
        "/api/cart/add",
        goods_items,
        (res) => {
          that.cart_count = that.cart_count + data.selectedNum;
          this.$toast("添加成功");
          that.showSkuPicker = false;
        },
        (res) => {
          if (res.code == 401 || res.code == 402) {
            that.loginShow = true;
            that.showSkuPicker = false;
          } else {
            Toast(res.msg);
          }
        }
      );
    },
    goCart() {
      localStorage.setItem("_self_cart", "cart");
      rbLink({
        name: "Cart",
        query: { business_id: this.detail.business_id },
      });
    },

    goBusiness() {
      rbLink({
        name: "Index",
        query: { business_id: this.detail.business_id },
      });
    },
    goOrderList() {
      rbLink({
        name: "OrderList",
        query: {},
      });
    },
    onPlayItems(i) {
      this.playMusicUrl = this.detail.music[i].url;
      this.playMusicName = this.detail.music[i].name;
      this.showMusic = true;
      this.mp3Active = i;
    },

    goHome() {
      rbLink({
        name: "GoodsIndex",
        query: { business_id: this.detail.business_id },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// GoodsDetail.vue?18029a03